import React from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { userLogout } from 'controller/auth';
import { useNavigate } from 'react-router-dom';
import Storage from 'utils/storage';
import Setting from 'ui-component/icons/setting';
import { LANGUAGE } from 'constants/common';
import { Divider, Space } from 'antd';
import ZhIcon from 'ui-component/icons/zh';
import EnIcon from 'ui-component/icons/en';
import Avatar from './avatar';
import IconLogout from 'ui-component/icons/logout';
import { useStyles } from './index.style';
import Notify from 'ui-component/Tools/Notify';

const CMP = () => {
  const navigate = useNavigate();
  const { styles } = useStyles();
  const { t, i18n } = useTranslation('common');

  const changeLanguage = (e: any) => {
    i18n.changeLanguage(e);
    Storage.set(LANGUAGE, e, true);
  };

  const userlogout = async () => {
    const res = await userLogout();
    if (res.success) {
      Notify('success', t('tips.logout', { ns: 'common' }));
      Storage.clear();
      navigate('/login');
    }
  };

  const goToSetting = () => {
    navigate('/setting');
  }

  return (
    <Space split={<Divider type="vertical" />} style={{ paddingRight: '50px' }}>
      <Space size="small">
        {i18n.language === 'en' ? (
          <div onClick={() => changeLanguage('zh')}>
            <ZhIcon width="20px" height="20px" className={styles.language} />
          </div>
        ) : (
          <div onClick={() => changeLanguage('en')}>
            <EnIcon width="20px" height="20px" className={styles.language} />
          </div>
        )}

        <Tooltip title="Setting">
        <span onClick={goToSetting}>
        <Setting width={22} height={22} className={styles.icon}  />
        </span>
         
        </Tooltip>
        <Tooltip title="Logout">
          <span onClick={userlogout}>
            <IconLogout width={20} height={20} className={styles.icon} />
          </span>
        </Tooltip>
      </Space>
    </Space>
  );
};

export default CMP;
